import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withModalActions } from 'core/hocs';
import { ModalWindow } from 'components/modal-window/modal-window';
import { PAYMENT_TYPES } from 'core/constants';
import { MODAL_IDS, PAGE_NAMES } from '../../../constants';
import { StatusNotificationModalContent } from '../status-notification-modal-content/status-notification-modal-content';

class PaymentCompletionModalUI extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    currentModal: PropTypes.shape({ data: PropTypes.string }).isRequired
  };

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal(MODAL_IDS.PAYMENT_COMPLETION);
  }

  render() {
    const { currentModal } = this.props;

    const modalData = (currentModal || {}).data;
    const { paymentType, isSuccess } = modalData || {};
    const isDeposit = paymentType === PAYMENT_TYPES.DEPOSIT;
    const title = `modal.${isDeposit ? 'deposit' : 'withdrawal'}.${isSuccess ? 'success' : 'fail'}-message.title`;
    const description = `modal.${isDeposit ? 'deposit' : 'withdrawal'}.${isSuccess ? 'success' : 'fail'}-message.description`;
    const buttonTitle = `button.${isSuccess ? 'check-payment-status' : 'try-again'}`;

    return (
      <ModalWindow
        id={MODAL_IDS.PAYMENT_COMPLETION}
        coreProps={{ id: MODAL_IDS.PAYMENT_COMPLETION }}
        isCentered
        fade
      >
        <StatusNotificationModalContent
          headerIntlKey={title}
          descIntlKey={description}
          onClick={this.closeModal}
          {...(isSuccess && { link: `/${PAGE_NAMES.BANKING_HISTORY}` })}
          buttonIntlKey={buttonTitle}
          isSuccess={isSuccess}
        />
      </ModalWindow>
    );
  }
}

export const PaymentCompletionModal = withModalActions(PaymentCompletionModalUI);
